import { useMemo } from 'react';

import { useGetAskMeAnythingChatHistory } from '@/api/generated';
import { extractResponse, extractThoughts } from '@/components/AskMeAnything/utils/chatUtil';

export const useChatHistory = (threadId: string, isGetThreadHistory: boolean) => {
  const {
    data,
    isLoading: isLoadingChatHistory,
    isFetching: isFetchingChatHistory,
    isError: isErrorChatHistory
  } = useGetAskMeAnythingChatHistory(threadId, {
    query: {
      enabled: !!threadId && isGetThreadHistory,
      initialData: {
        kind: 'journey:agent:chat:history',
        items: [
          {
            messages: []
          }
        ],
        count: 0
      },
      refetchOnWindowFocus: false
    }
  });

  const chatHistory = useMemo(
    () =>
      data?.items?.[0]?.messages?.map(item => ({
        type: item.type,
        response: item.type === 'ai' ? extractResponse(item.message ?? '') : item.message,
        thoughts: item.type === 'ai' ? extractThoughts(item.message ?? '') : ''
      })) || [],
    [data]
  );

  return {
    chatHistory,
    isLoadingChatHistory,
    isFetchingChatHistory,
    isErrorChatHistory
  };
};
